import {
  ChangeDetectionStrategy,
  Component,
  inject,
  computed,
} from '@angular/core'
import { RouterModule } from '@angular/router'

import { TypographyComponent } from '@hyperkit'

import { SessionService } from '@hunt/services'
import { HuntViewService, HuntEditorService } from '@hunt/services'

import { ReportTextBlockComponent } from '../report-text-block/report-text-block.component'

@Component({
  standalone: true,
  selector: 'final-report-overview',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [RouterModule, TypographyComponent, ReportTextBlockComponent],
  templateUrl: './final-report-overview.component.html',
  styleUrls: ['./final-report-overview.component.scss'],
})
export class FinalReportOverviewComponent {
  readonly huntView = inject(HuntViewService)
  readonly huntEditor = inject(HuntEditorService)
  readonly session = inject(SessionService)
  readonly loaded = computed(
    () => !this.session.loading() && this.session.activeHunt() !== null,
  )
}
